/**
 * Catch-all 404 page.
 *
 * Without a `path: "*"` route, React Router renders its default developer
 * error boundary ("Unexpected Application Error!") for any unmatched URL.
 *
 * The route keeps unknown SPA URLs from showing React Router's default
 * developer-oriented error boundary.
 *
 * The way out is the one destination this app has. It said Events until
 * #142, a line carried across from the RMS workspace at the fork, and
 * `/events` here is a 301 to that workspace — so a Company that mistyped
 * a URL was sent to a product it may not run.
 */
import { Link } from "react-router";

import styles from "./not-found.module.css";

export default function NotFound() {
  return (
    <main className={styles.page}>
      <p className={styles.code}>404</p>
      <h1 className={styles.heading}>Page not found</h1>
      <p className={styles.message}>That page doesn’t exist.</p>
      <Link to="/enquiries" className={styles.backLink}>
        Back to Enquiries
      </Link>
    </main>
  );
}
